<template>
  <div>
    <div class="pa-2">
      <transition
      name="slide-x-reverse-transition"
      mode="out-in">

        <!-- ITEMS -->
        <div 
        v-if="selectedCount === 0"
        key="1"
        class="c-flex-r align-center subheading">

          <!-- select menu -->
          <v-menu offset-y>
            <template v-slot:activator="{ on }">
              <v-btn
                icon
                v-on="on"
              >
                <v-icon>mdi-check-box-multiple-outline</v-icon>
              </v-btn>
            </template>
            <v-list>
              <v-list-item
              @click="selectAll">
                <v-list-item-title>Select all</v-list-item-title>
              </v-list-item>
              <v-list-item
              @click="selectPage">
                <v-list-item-title>Select page</v-list-item-title>
              </v-list-item>
              <v-list-item
              @click="selectNone">
                <v-list-item-title>Select none</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>

          <v-btn
          text
          outlined
          class="mr-2"
          @click="addBox">
            <v-icon>add</v-icon>
            <div class="ml-1 text--text">
              Add Box
            </div>
          </v-btn>

        </div>

        <!-- selected count -->
        <div v-if="selectedCount > 0"
        key="2"
        class="c-flex-r align-center subheading">
          <v-btn
          icon
          class=""
          @click="selected = {}">
            <v-icon color="color1">close</v-icon>
          </v-btn>
          <div class="text-sans font-weight-bold">
            <span>&nbsp;{{ selectedCount }}</span>
            selected 
          </div>
          <v-spacer v-if="$vuetify.breakpoint.xs"></v-spacer>
          <span class="icon--text ml-2">|</span>
          <v-btn 
          icon
          @click="onDelete">
            <v-icon>delete_outline</v-icon>
          </v-btn>
          <!-- select menu -->
          <v-menu offset-y>
            <template v-slot:activator="{ on }">
              <v-btn
                icon
                v-on="on"
              >
                <v-icon>mdi-check-box-multiple-outline</v-icon>
              </v-btn>
            </template>
            <v-list>
              <v-list-item
              @click="selectAll">
                <v-list-item-title>Select all</v-list-item-title>
              </v-list-item>
              <v-list-item
              @click="selectPage">
                <v-list-item-title>Select page</v-list-item-title>
              </v-list-item>
              <v-list-item
              @click="selectNone">
                <v-list-item-title>Select none</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </div>

      </transition>
    </div>

    <table class="final-table th-no-padding lines-b pointer hover full-width">
      <colgroup ref="colgroup1">
        <col width="30px">
        <col width="15px">
        <col width="15px">
      </colgroup>

      <draggable 
      :list="items"
      :element="'tbody'"
      :options="{animation: 150, handle: '.drag-handle'}"
      @change="dragChange">
        <box-row 
        v-for="item in items" 
        :key="item.tempID"
        :item="item"
        :saleItems="saleItems"
        :selected="selected"
        :itemsMeta="{}"
        :activeBox="activeBox"
        @click.native="clickRow(item)"
        @checkRow="checkRow(item)"
        outlined 
        class="pa-2 align-top">
        </box-row>
      </draggable>
    
    </table>
  </div>
</template>

<script>
import ListController from "@/mixins/ListController"
import BoxRow from "./box-row"
import Draggable from 'vuedraggable'

export default {
  props: {
    itemSource: {
      type: Array
    },
    activeBox: null,
    saleItems: null
  },
  mixins: [ListController],
  components: {
    BoxRow,
    Draggable
  },
  watch: {
    itemSource: {
      immediate: true,
      handler (items) {
        this.items = items
      }
    },
    items (nv) {
      this.$emit('update:itemsSource', nv)
    }
  },
  methods: {
    addBox () {
      this.items.push({
        box: this.items.length + 1
      })
    },
    clickRow (item) {
      if (this.selectedCount > 0) {
        this.checkRow(item)
      } else {
        // this.$emit('onClickRow', item)
        this.$emit('update:activeBox', item.tempID)
      }
    },
    onDelete() {
      var selectedRows = this.getSelectedRows();
      var idArray = selectedRows.reduce((a, i) => {
        a.push(i.tempID);
        return a;
      }, []);
      var title = "Delete " + idArray.length + " item" + (idArray.length === 1 ? "" : "s") + "?"
      this.$root.$confirm(title, "Are you sure?", { color: "purple" })
        .then(confirm => {
          if (confirm) {
            for (var i = this.items.length - 1; i >= 0; --i) {
              if (idArray.includes(this.items[i].tempID)) {
                this.items.splice(i, 1);
              }
            }
            this.onSuccessfullDelete();
          }
        });
    },
  }
}
</script>